(function () {
    'use strict';

    angular
        .module('invesfleet')
        .factory('audioService', audioService);

    audioService.$inject = ['preferences'];

    function audioService(preferences) {

        var MAX_QUEUE_LENGTH = 10;

        var mute = false;

        var audio = null;

        var isPlaying = false;
        var soundQueue = [];
        
        return {
            toggleMute: function () {
                mute = !mute;
                if(audio){
                    audio.volume = mute? 0 : 1;
                }
                return mute;
            },
            isMuted: function () {
                return mute;
            },

            play: play,

            notification: {
                nuevas: nuevasNot,
                demora: demoraNot,
                pendientes: pendientesNot,
                programadas: programadasNot,
                asignado: asignadoNot,
                entregado: entregadoNot,
                aceptado: aceptadoNot,
                rechazado: rechazadoNot,
                iniciado: iniciadoNot,
                localizado: localizadoNot,
                finalizado: finalizadoNot,
                msg: msgNot,
                opOnline: opOnlineNot
            }
        };



        function play(audioPath){
            if(isPlaying){
                if(soundQueue.length < MAX_QUEUE_LENGTH){
                    soundQueue.push(audioPath);
                }
            } else {
                startPlaying(audioPath);
            }
        }

        function nuevasNot(){
            if(preferences.prefs.companyPrefs.soundNuevas){
                //console.log('NOT -> Nuevas ordenes');
                play('content/' + preferences.prefs.companyPrefs.fileSoundNueva + '.mp3');
            }
        }

        function demoraNot(){
            if(preferences.prefs.companyPrefs.soundDemoras){
                //console.log('NOT -> Demora ordenes');
                play('content/' + preferences.prefs.companyPrefs.fileSoundDemora + '.mp3');
            }
        }

        function pendientesNot(){
            if(preferences.prefs.companyPrefs.soundPendientes){
                //console.log('NOT -> Pendientes ordenes');
                play('content/' + preferences.prefs.companyPrefs.fileSoundPendiente + '.mp3');
            }
        }

        function programadasNot(){
            if(preferences.prefs.companyPrefs.soundProgramadas){
                //console.log('NOT -> Programadas ordenes');
                play('content/' + preferences.prefs.companyPrefs.fileSoundProgramada + '.mp3');
            }
        }

        function asignadoNot(){
            if(preferences.prefs.companyPrefs.soundAsignado){
                //console.log('NOT -> Asignadas ordenes');
                play('content/' + preferences.prefs.companyPrefs.fileSoundAsignado + '.mp3');
            }
        }

        function entregadoNot(){
            if(preferences.prefs.companyPrefs.soundEntregado){
                //console.log('NOT -> Entregada ordenes');
                play('content/' + preferences.prefs.companyPrefs.fileSoundEntregado + '.mp3');
            }
        }

        function aceptadoNot(){
            if(preferences.prefs.companyPrefs.soundAceptado){
                //console.log('NOT -> Aceptada ordenes');
                play('content/' + preferences.prefs.companyPrefs.fileSoundAceptado + '.mp3');
            }
        }

        function rechazadoNot(){
            if(preferences.prefs.companyPrefs.soundRechazado){
                //console.log('NOT -> Rechazado ordenes');
                play('content/' + preferences.prefs.companyPrefs.fileSoundRechazado + '.mp3');
            }
        }

        function iniciadoNot(){
            if(preferences.prefs.companyPrefs.soundIniciado){
                //console.log('NOT -> Iniciado ordenes');
                play('content/' + preferences.prefs.companyPrefs.fileSoundIniciado + '.mp3');
            }
        }

        function localizadoNot(){
            if(preferences.prefs.companyPrefs.soundLocalizado){
                //console.log('NOT -> Localizado ordenes');
                play('content/' + preferences.prefs.companyPrefs.fileSoundLocalizado + '.mp3');
            }
        }

        function finalizadoNot(){
            if(preferences.prefs.companyPrefs.soundFinalizado){
                //console.log('NOT -> Finalizado ordenes');
                play('content/' + preferences.prefs.companyPrefs.fileSoundFinalizado + '.mp3');
            }
        }
        
        function msgNot(){
            if(preferences.prefs.companyPrefs.soundRecMessages){
                //console.log('NOT -> MSG nuevo');
                play('content/' + preferences.prefs.companyPrefs.fileSoundRecMessages + '.mp3');
            }
        }
        
        function opOnlineNot(){
            if(preferences.prefs.companyPrefs.soundOpOnline){
                //console.log('NOT -> Operario online');
                play('content/' + preferences.prefs.companyPrefs.fileSoundOpOnline + '.mp3');
            }
        }

        function startPlaying(url) {
            isPlaying = true;

            audio = new Audio(url);
            audio.volume = mute? 0 : 1;
            audio.onended = function(){
                if(soundQueue.length > 0){
                    startPlaying(soundQueue.shift()); 
                } else {
                    isPlaying = false;
                }
            };

            var playPromise = audio.play();
            if (playPromise !== undefined) {
                playPromise.then(_ => {
                    // Automatic playback started!
                    // Show playing UI.
                }).catch(error => {
                  // Auto-play was prevented
                  // Show paused UI.
                });
            }
            
        }
    }
})();